import Home from "./home/Home";
import MyProperties from "./myProperties/MyProperties";
import MyProperties2 from "./myPropertiesSimplified/MyPropertiesSimplified";
import Login from "./login/Login";
import EsqueceuSenha from "./esqueceuSenha/EsqueceuSenha";
import RegistryReservation from "./registryReservation/RegistryReservation";
import StudioManagement from "./studioManagement/StudioManagement";
import CleaningAndMaintenance from "./cleaningAndMaintenance/CleaningAndMaintenance";
import Reservation from "./reservation/Reservation";
import RegisterOwners from "./registerOwners/RegisterOwners";
import MangerRegistryPage from "./managerRegistry/managerRegistryPage";
import RegisterServiceProvider from "./registerServiceProvider/registerServiceProvider";
import RegisterTenant from "./registerTenant/RegisterTenant";
import SteakhouseRentalPage from "./steakhouseRental/SteakhouseRentalPage";
import Monitoring from "./monitoring/Monitoring";
const pages = {
  Home,
  Login,
  EsqueceuSenha,
  MyProperties,
  MyProperties2,
  RegistryReservation,
  StudioManagement,
  CleaningAndMaintenance,
  Reservation,
  RegisterOwners,
  MangerRegistryPage,
  RegisterServiceProvider,
  RegisterTenant,
  SteakhouseRentalPage,
  Monitoring,
};
export default pages;
